import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from './ui/Card'

interface ReadinessWidgetProps {
  score: number | null
  grade: string | null
  missing?: string[]
}

function gradeTone(score: number | null): string {
  if (score == null) return 'text-text-muted'
  if (score >= 80) return 'text-emerald-600'
  if (score >= 60) return 'text-amber-600'
  return 'text-red-600'
}

export function ReadinessWidget({ score, grade, missing }: ReadinessWidgetProps) {
  const { t } = useTranslation()
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('brief_detail.readiness.title')}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex items-baseline gap-3">
          <span className={`text-3xl font-bold ${gradeTone(score)}`}>
            {score != null ? score : '—'}
          </span>
          {grade && (
            <span className="font-mono text-lg text-text-muted">{grade}</span>
          )}
        </div>
        {missing && missing.length > 0 && (
          <div>
            <p className="text-xs font-medium text-text-muted">
              {t('brief_detail.readiness.missing')}
            </p>
            <ul className="mt-1 list-inside list-disc text-xs text-text-muted">
              {missing.slice(0, 8).map((m) => (
                <li key={m}>{m}</li>
              ))}
            </ul>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
